import { render, staticRenderFns } from "./name.vue?vue&type=template&id=1eb183a1&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb183a1')) {
      api.createRecord('1eb183a1', component.options)
    } else {
      api.reload('1eb183a1', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=1eb183a1&", function () {
      api.rerender('1eb183a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/risk/name.vue"
export default component.exports